import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';
import { _ } from '@ngx-translate/core';

export const baseErrorStatusLocalize = {
  [BaseErrorStatus.BadRequest]: _(`@@base-error-status-descriptions__bad-request`),
  [BaseErrorStatus.FailedTooManyCalls]: _(`@@shared-too-many-requests__text`),
  [BaseErrorStatus.TooManyRequests]: _(`@@shared-too-many-requests__text`),
  [BaseErrorStatus.FailedUnexpected]: _(`@@base-error-status-descriptions__failed-unexpected`),
  [BaseErrorStatus.MalformedInputData]: _(`@@base-error-status-descriptions__malformed-input-data`),
  [BaseErrorStatus.InternalServerError]: _(`@@base-error-status-descriptions__internal-server-error`),
};
